import FetchHelpers from '../../utils/FetchHelpers';
import formUrl from '../../utils/routes';
import { toFormData } from '../../utils/formUtils';

export default {
  create(params) {
    const url = formUrl(`api/v1/admin/users/multiples_bonuses`);
    return FetchHelpers.post(url, params);
  },
};
